export default {
  computed: {
    shippingOrdersQuickFilters() {
      return {
        title: 'Shipping Orders',
        // overrides: {
        //   'order-id': {
        //     'order-delivery-date': {
        //       dateRangeActive: false
        //     },
        //     'reference-location': null
        //   }
        // },
        filters: {
          columns: [
            {
              class: 'col-6 col-md-2',
              filters: [
                {
                  name: 'reference-location',
                  label: this.$gettext('Reference Location'),
                  type: this.ecosystemConfig?.modelOverrides?.referenceLocations?.type || 'text',
                  options: [
                    {
                      text: this.$gettext('None'),
                      value: null
                    },
                    ...(this.ecosystemConfig?.modelOverrides?.referenceLocations?.options || [])
                  ],
                  value: this.profile?.meta?.persistentStorage?.referenceLocation || null,
                  callback: (val, filtersState) => {
                    if (!filtersState['order-id'] && val) {
                      return [[ 'reference_location', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-id',
                  label: this.$gettext('Order ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return {
                        or: true,
                        filters: [
                          [ 'id', 'eq', val.trim() ],
                          [ 'external_id', 'eq', val.trim() ]
                        ]
                      }
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-status',
                  label: this.$gettext('Future/Active'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    {
                      text: this.$gettext('Future'),
                      value: 1
                    },
                    {
                      text: this.$gettext('Active'),
                      value: false
                    }
                  ],
                  value: null,
                  stacked: true,
                  callback: (val) => {
                    if (val === 1) {
                      return [[ 'status', 'eq', 'draft' ]]
                    } else if (val === false) {
                      return [[ 'status', 'eq', 'draft', 'true' ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-md-3',
              filters: [
                {
                  name: 'status',
                  label: this.$gettext('Specific Statuses'),
                  type: 'checkbox-group',
                  options: [
                    {
                      text: this.$gettext('Draft'),
                      value: 'draft'
                    },
                    {
                      text: this.$gettext('Pending'),
                      value: 'pending'
                    },
                    {
                      text: this.$gettext('Confirmed'),
                      value: 'confirmed'
                    },
                    {
                      text: this.$gettext('Error'),
                      value: 'error'
                    },
                    {
                      text: this.$gettext('Canceled'),
                      value: 'canceled'
                    },
                    {
                      text: this.$gettext('Done'),
                      value: 'done'
                    }
                  ],
                  value: [],
                  stacked: true,
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'status', 'in', val ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-delivery-date',
                  label: this.$gettext('Est. Delivery Date Range'),
                  type: 'daterange',
                  opens: 'right',
                  value: {
                    startDate: new Date(this.moment().startOf('day').format('YYYY-MM-DD')),
                    endDate: new Date(this.moment().endOf('day').format('YYYY-MM-DD')),
                    dateRangeActive: true
                  },
                  // ranges: {
                  //   [this.$gettext('Today')]: [new Date(this.moment().startOf('day').format('YYYY-MM-DD')), new Date(this.moment().endOf('day').format('YYYY-MM-DD'))],
                  //   [this.$gettext('Yesterday')]: [new Date(this.moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD'))],
                  //   [this.$gettext('Last 7 days')]: [new Date(this.moment().subtract(6, 'day').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().endOf('day').format('YYYY-MM-DD'))],
                  //   [this.$gettext('Tomorrow')]: [new Date(this.moment().add(1, 'days').startOf('day').format('YYYY-MM-DD')), new Date(this.moment().add(1, 'days').endOf('day').format('YYYY-MM-DD'))],
                  //   [this.$gettext('Next 7 days')]: [new Date(this.moment().startOf('day').format('YYYY-MM-DD')), new Date(this.moment().add(6, 'days').endOf('day').format('YYYY-MM-DD'))]
                  // },
                  callback: (val, filtersState) => {
                    console.log('FILTERS STATE*********', filtersState)

                    if (!filtersState['order-id'] && val.dateRangeActive) {
                      const range = [
                        this.moment(val.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                        this.moment(val.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
                      ]
                      return [[ 'delivery_date', 'bt', range ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-md-3',
              filters: [
                {
                  name: 'order-origin',
                  label: this.$gettext('Origin'),
                  type: 'geofence-autocomplete',
                  minCharacter: 3,
                  value: '',
                  callback: (val) => {
                    if (val.external_id) {
                      return [[ 'origin_location', 'eq', val.external_id.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-destination',
                  label: this.$gettext('Destination'),
                  type: 'geofence-autocomplete',
                  minCharacter: 3,
                  value: '',
                  callback: (val) => {
                    if (val.external_id) {
                      return [[ 'destination_location', 'eq', val.external_id.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'commodity',
                  label: this.$gettext('Commodity'),
                  type: 'commodity-autocomplete',
                  minCharacter: 3,
                  value: '',
                  callback: (val) => {
                    if (val.id) {
                      return [[ 'commodity_id', 'eq', val.id ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'equipment',
                  label: this.$gettext('Equipment Type'),
                  type: 'vehicle-type-autocomplete',
                  minCharacter: 3,
                  value: '',
                  remote: true,
                  callback: (val) => {
                    if (val.id) {
                      return [[ 'vehicle_type_id', 'eq', val.id ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'program-field',
                  label: this.$gettext('Program'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return {
                        or: true,
                        filters: [
                          [ 'program_field', 'ct', val.trim() ]
                        ]
                      }
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: '',
              filters: [
                {
                  name: 'company-id',
                  label: this.$gettext('Customer'),
                  type: 'company-autocomplete',
                  restrictTo: [['relationship', 'eq', 'client']],
                  // placeholder: this.$gettext('User name or email'),
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      const customers = val.map(function (item) {
                        return item.id
                      })
                      return [[ 'company_id', 'in', customers ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'courier-company-id',
                  label: this.$gettext('Carrier'),
                  type: 'company-autocomplete',
                  restrictTo: [['relationship', 'eq', 'provider']],
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      // Old courier_company_id
                      const carriers = val.map(function (item) {
                        return item.id
                      })
                      return [[ 'shipping_order_courier_company.courier_company_id', 'in', carriers ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'applied-by',
                  label: this.$gettext('Created by'),
                  type: 'user-autocomplete',
                  // restrictToRoles: ['courier'],
                  placeholder: this.$gettext('User name or email'),
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      const users = val.map(function (item) {
                        return item.id
                      })
                      return [[ 'applied_by_id', 'in', users ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-services',
                  label: this.$gettext('Order Services'),
                  type: 'order-service-autocomplete',
                  minCharacter: 3,
                  value: [],
                  callback: (val) => {
                    if (val.length > 0) {
                      const services = val.map(function (item) {
                        return item.id
                      })
                      return [[ 'order_services.id', 'in', services ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'order-type',
                  label: this.$gettext('Order Type'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    ...(this.ecosystemConfig?.modelOverrides?.orderTypes?.options || [])
                  ],
                  value: null,
                  stacked: false,
                  callback: (val) => {
                    if (val) {
                      return [[ 'type', 'eq', val ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
